module.exports = __webpack_public_path__ + "static/img/報告書説明.b7cf0ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/報告書説明.png
// module id = 594
// module chunks = 0